import * as React from 'react';

import { cn } from '@/lib/utils';

interface SelectionCheckboxProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: 'pill' | 'box';
  checked: boolean;
}

const SelectionCheckbox = React.forwardRef<HTMLDivElement, SelectionCheckboxProps>(
  ({ className, variant = 'box', checked, ...props }, ref) => (
    <div
      ref={ref}
      role="checkbox"
      aria-checked={checked}
      className={cn(
        'shrink-0 flex items-center justify-center transition-all duration-150',
        'border bg-black/60 border-white/70 backdrop-blur-sm',
        'hover:border-active-gold/80 hover:shadow-sm',
        checked && 'bg-active-gold border-active-gold text-background shadow-md',
        variant === 'pill' ? 'w-7 h-7 rounded-full' : 'w-6 h-6 rounded-md',
        className
      )}
      {...props}
    >
      {checked && (
        <svg
          className={cn(
            'fill-current',
            variant === 'pill' ? 'w-4 h-4' : 'w-3.5 h-3.5'
          )}
          viewBox="0 0 24 24"
        >
          <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" />
        </svg>
      )}
    </div>
  )
);

SelectionCheckbox.displayName = 'SelectionCheckbox';

export { SelectionCheckbox };
